import { render, staticRenderFns } from "./loaderMini.vue?vue&type=template&id=bfe4beac&scoped=true&"
import script from "./loaderMini.vue?vue&type=script&lang=js&"
export * from "./loaderMini.vue?vue&type=script&lang=js&"
import style0 from "./loaderMini.vue?vue&type=style&index=0&id=bfe4beac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe4beac",
  null
  
)

export default component.exports